// extracted by mini-css-extract-plugin
export default {"effectiveDates":"EffectiveDates_effectiveDates__oBAyA"};